module.exports = __webpack_public_path__ + "img/yjy.fcd00bc7.png";